import React from 'react';
import styled, {css} from 'styled-components';
import {get} from 'lodash-es';
import Button from '@material-ui/core/Button';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

function gridColorize({ r, c }) {
  let r_ = r % 2 === 1
  let c_ = c % 2 === 1
  let h = ` &:hover { filter: brightness(70%); }`
  if (r_ && c_) return `filter: brightness(85%); ${h}`
  if (r_) return `filter: brightness(90%); ${h}`
  if (c_) return `filter: brightness(95%); ${h}`
  return h;
}

// cols recebe array contendo os tamanhos de cada coluna, no padrão do template-columns.
// Automaticamente os campos contendo pixels são convertidos para fit-content, ou seja,
// o valor passado fica sendo o caso "máximo". Para que os valores passados em cols sejam
// "estritos", passar a prop fixedCols como true.
function formataColunasGrid(props) {
  let { cols, fixedCols } = props;
  if (fixedCols) return cols.join(" ");
  return cols.map(c => c.includes("px") ? `fit-content(${c})` : c).join(" ");
}

const Table = styled.div`
  border: 1px solid #ccc;
  display: grid;
  grid-template-columns: ${formataColunasGrid};
  width: ${props => props.width || "100%"};
  font-size: 12px;
  /* grid-auto-rows: 40px; */
`
const Item = styled.div`
  display: flex;
  background: #fff;
  padding: 3px 8px 3px 1px;
  ${props => props.align && props.align === "right" && css`
    justify-content: flex-end;
  `}
  ${props => props.bold && css`
    font-weight: bold;
  `}
  ${props => props.onClick && css`
    cursor: pointer;
  `}
  ${gridColorize}
`
const SortedIcon = styled(ExpandMoreIcon).attrs({
  style: { 
    fontSize: 14,
    marginLeft: 3,
  }
})`
  color: gray;
  font-size: 10px;
  ${props => props.oDesc && `
    transform: rotate(180deg);  
  ` }
`

function DataList (props) {
  const { data, dataIdx } = props;
  return data.map((d,r) => (
    dataIdx.map((idx,c) => <DataCell {...props} row={d} r={r} c={c} idx={idx} />)
  ))
}
function DataCell (props) {
  let { row, idx, r, c,
    modif={},
    comps={},
    align
  } = props;
  align = get(align,idx)
  let fn = get(modif,idx)
  let val = get(row,idx,"")
  let El = get(comps,idx)
  if (fn) val = fn(val)
  val = El ? (
    <El v={val} c={c} r={r+1}>{val}</El>
  ) : <>{val}</>
  return (
    <Item c={c} r={r+1} align={align}>{val}</Item>
  )
}

function HeaderRow (props) {
  const { title, sort, setSort, dataIdx } = props;
  let headerOnClick = (idx) => {
    if (!setSort) return false
    return setSort(dataIdx[idx]);
  }
  return title.map((t,c) => (
    <Item bold c={c} r={0} onClick={headerOnClick(c)}>
      {t}
      {sort && sort.by===dataIdx[c] && <SortedIcon oDesc={sort.desc} />}
    </Item>
  ))
}

export default function DataTable(props) {
  const {
    cols, 
    title, 
    data, 
    width, 
    dataIdx,
    more={},
    lastLine,
    fixedCols
  } = props;
  let { hasMore, next } = more
  let numCols = title.length;
  return (
    <Table cols={cols} fixedCols={fixedCols} width={width}>
      {title && <HeaderRow {...props} />}
      <DataList {...props}/>
      {lastLine && dataIdx.map((t,c) => (
        <DataCell {...props} row={lastLine} r={data.length + 2} c={c} idx={t}/>
      ))}
      { hasMore && (
        <More numCols={numCols}>
          <Button onClick={next}>Ver Mais...</Button>
        </More>
      )}
    </Table>
  )
}

const More = styled.div`
  grid-column: 1 / ${props => props.numCols};
  display: flex;
  justify-content: center;
`
